<template>
  <v-app>
    <div v-if="userLoading || pageLoading" class="cx-loader-overlay">
      <div class="cx-loader-card">
        <div class="cx-loader-pulse">
          <div class="cx-loader-pulse-dot"></div>
        </div>
        <p class="cx-loader-title">{{ loadingMessage || 'Loading your workspace' }}</p>
        <p class="cx-loader-hint">{{ hints[hintIndex] }}</p>
        <div class="cx-loader-progress">
          <div class="cx-loader-progress-bar"></div>
        </div>
      </div>
    </div>
    <app-auth v-else-if="!authState"></app-auth>
    <app-layout v-else-if="authState"></app-layout>
  </v-app>
</template>

<script>
import Layout from './views/AppLayout.vue'
import Auth from './views/AuthPage.vue'
export default {
  name: 'App',
  data: () => ({
    hints: [
      'Fetching your data…',
      'Setting things up…',
      'Almost there…',
      'Just a moment…',
      'Polishing the pixels…',
    ],
    hintIndex: 0,
    hintTimer: null,
  }),
  computed: {
    userLoading() {
      return this.$store.getters.loadedUserLoading
    },
    pageLoading() {
      return this.$store.getters.loadedPageLoading
    },
    loadingMessage() {
      return this.$store.getters.loadingMessage
    },
    authState() {
      return this.$store.getters.loggedIn
    }
  },
  components: {
    AppLayout: Layout,
    AppAuth: Auth,
  },
  mounted() {
    this.hintTimer = setInterval(() => {
      this.hintIndex = (this.hintIndex + 1) % this.hints.length
    }, 2200)
  },
  beforeDestroy() {
    if (this.hintTimer) clearInterval(this.hintTimer)
  },
};
</script>

<style scoped>
/* ─── Global loader (glass) ──────────────────────────────────────── */
.cx-loader-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  background:
    radial-gradient(ellipse at 20% 0%, rgba(20, 184, 166, 0.08), transparent 60%),
    radial-gradient(ellipse at 80% 100%, rgba(99, 102, 241, 0.08), transparent 60%);
  backdrop-filter: blur(5px) saturate(120%);
  -webkit-backdrop-filter: blur(5px) saturate(120%);
  animation: cx-fade-in 0.25s ease-out;
}

.cx-loader-card {
  position: relative;
  min-width: 280px;
  max-width: 92vw;
  padding: 22px 28px 20px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(20px) saturate(160%);
  -webkit-backdrop-filter: blur(20px) saturate(160%);
  box-shadow:
    0 16px 40px -16px rgba(0, 60, 80, 0.18),
    0 0 0 1px rgba(255, 255, 255, 0.6) inset,
    0 0 0 1px rgba(15, 23, 42, 0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
}

.cx-loader-pulse { width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; }
.cx-loader-pulse-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #14b8a6, #6366f1);
  box-shadow: 0 0 0 0 rgba(20, 184, 166, 0.45);
  animation: cx-pulse 1.8s ease-in-out infinite;
}

@keyframes cx-pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(20, 184, 166, 0.45), 0 0 0 0 rgba(99, 102, 241, 0.30);
  }
  50% {
    transform: scale(1.15);
    box-shadow: 0 0 0 12px rgba(20, 184, 166, 0), 0 0 0 22px rgba(99, 102, 241, 0);
  }
}

.cx-loader-title { font-size: 15px; font-weight: 600; margin: 0; color: #0f172a; letter-spacing: -0.01em; }
.cx-loader-hint {
  font-size: 12.5px;
  color: #64748b;
  margin: 0;
  min-height: 16px;
  animation: cx-fade-hint 2.2s ease-in-out infinite;
}

@keyframes cx-fade-hint {
  0%, 100% { opacity: 0.5; transform: translateY(2px); }
  50% { opacity: 1; transform: translateY(0); }
}

.cx-loader-progress {
  width: 100%;
  height: 3px;
  border-radius: 3px;
  background: rgba(20, 184, 166, 0.10);
  overflow: hidden;
  margin-top: 2px;
}

.cx-loader-progress-bar {
  height: 100%;
  width: 35%;
  background: linear-gradient(90deg, #14b8a6, #6366f1, #ec4899);
  border-radius: 3px;
  animation: cx-progress 1.6s ease-in-out infinite;
}

@keyframes cx-progress {
  0% { margin-left: -35%; }
  50% { margin-left: 50%; width: 50%; }
  100% { margin-left: 105%; width: 35%; }
}

@keyframes cx-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>
